/* eslint-disable import/no-anonymous-default-export */

import StaffActionTypes from "./staff.types";
import { docodeHexResponse } from "../../_common/common.utils";

const INITIAL_STATE = {
  addStaffDetailsResponse: null,
  updateStaffDetailsResponse: null,
  getStaffListResponse: null,
  getStaffListArr: [],
  fetchStaffDetailsResponse: null,
  fetchStaffDetailsArr: [],
  deleteStaffDetailsResponse: null,
  getBranchDropdownListResponse: null,
  getBranchDropdownListArr: [],
  getUserTypeDropdownListResponse: null,
  getUserTypeDropdownListArr: [],
  getDepartmentDropdownListResponse: null,
  getDepartmentDropdownListArr: [],
  getManagerDropdownListResponse: null,
  getManagerDropdownListArr: [],
};

export default (state = INITIAL_STATE, action: any) => {
  switch (action.type) {
    /** ***************** ADD STAFF DETAILS START *********************** */
    case StaffActionTypes.ADD_STAFF_DETAILS_SUCCESS:
      return { ...state, addStaffDetailsResponse: action.payload };

    case StaffActionTypes.ADD_STAFF_DETAILS_FAILURE:
      return { ...state, addStaffDetailsResponse: action.payload };

    case StaffActionTypes.ADD_STAFF_DETAILS_RESPONSE_CHANGED:
      return { ...state, addStaffDetailsResponse: null };
    /** ***************** ADD STAFF DETAILS END *********************** */

    /** ***************** UPDATE STAFF DETAILS START *********************** */
    case StaffActionTypes.UPDATE_STAFF_DETAILS_SUCCESS:
      return { ...state, updateStaffDetailsResponse: action.payload };

    case StaffActionTypes.UPDATE_STAFF_DETAILS_FAILURE:
      return { ...state, updateStaffDetailsResponse: action.payload };

    case StaffActionTypes.UPDATE_STAFF_DETAILS_RESPONSE_CHANGED:
      return { ...state, updateStaffDetailsResponse: null };
    /** ***************** UPDATE STAFF DETAILS END *********************** */

    /** ***************** GET STAFF DETAILS START *********************** */
    case StaffActionTypes.GET_STAFF_LIST_SUCCESS:
      return {
        ...state,
        getStaffListResponse: action.payload,
        getStaffListArr: docodeHexResponse(
          action.payload,
          "GetAllUserPaginationKey",
        ),
      };

    case StaffActionTypes.GET_STAFF_LIST_FAILURE:
      return { ...state, getStaffListResponse: action.payload };

    case StaffActionTypes.GET_STAFF_LIST_RESPONSE_CHANGED:
      return { ...state, getStaffListResponse: null };
    /** ***************** GET STAFF DETAILS END *********************** */

    /** ***************** FETCH STAFF DETAILS START *********************** */
    case StaffActionTypes.FETCH_STAFF_DETAILS_SUCCESS:
      return {
        ...state,
        fetchStaffDetailsResponse: action.payload,
        fetchStaffDetailsArr: docodeHexResponse(
          action.payload,
          "FetchUserLoginKey",
        ),
      };

    case StaffActionTypes.FETCH_STAFF_DETAILS_FAILURE:
      return { ...state, fetchStaffDetailsResponse: action.payload };

    case StaffActionTypes.FETCH_STAFF_DETAILS_RESPONSE_CHANGED:
      return {
        ...state,
        fetchStaffDetailsResponse: null,
        fetchStaffDetailsArr: [],
      };
    /** ***************** FETCH STAFF DETAILS END *********************** */

    /** ***************** DELETE STAFF DETAILS START *********************** */
    case StaffActionTypes.DELETE_STAFF_DETAILS_SUCCESS:
      return { ...state, deleteStaffDetailsResponse: action.payload };

    case StaffActionTypes.DELETE_STAFF_DETAILS_FAILURE:
      return { ...state, deleteStaffDetailsResponse: action.payload };

    case StaffActionTypes.DELETE_STAFF_DETAILS_RESPONSE_CHANGED:
      return { ...state, deleteStaffDetailsResponse: null };
    /** ***************** DELETE STAFF DETAILS END *********************** */

    /** ***************** GET BRANCH LIST DETAILS START *********************** */
    case StaffActionTypes.LIST_BRANCH_DROPDOWN_DETAILS_SUCCESS:
      return {
        ...state,
        getBranchDropdownListResponse: action.payload,
        getBranchDropdownListArr: docodeHexResponse(
          action.payload,
          "GetAllBranchKey",
        ),
      };

    case StaffActionTypes.LIST_BRANCH_DROPDOWN_DETAILS_RESPONSE_CHANGED:
      return { ...state, getBranchDropdownListResponse: action.payload };

    // eslint-disable-next-line no-duplicate-case
    case StaffActionTypes.LIST_BRANCH_DROPDOWN_DETAILS_RESPONSE_CHANGED:
      return { ...state, getBranchDropdownListResponse: null };
    /** ***************** GET BRANCH LILST  DETAILS END *********************** */

    /** ***************** GET USERTYPE LIST DETAILS START *********************** */
    case StaffActionTypes.GET_USERTYPE_DROPDOWN_LIST_SUCCESS:
      return {
        ...state,
        getUserTypeDropdownListResponse: action.payload,
        getUserTypeDropdownListArr: docodeHexResponse(
          action.payload,
          "GetAllUserTypeKey",
        ),
      };

    case StaffActionTypes.GET_USERTYPE_DROPDOWN_LIST_FAILURE:
      return { ...state, getUserTypeDropdownListResponse: action.payload };

    case StaffActionTypes.GET_USERTYPE_DROPDOWN_LIST_RESPONSE_CHANGED:
      return { ...state, getUserTypeDropdownListResponse: null };
    /** ***************** GET USERTYPE LILST  DETAILS END *********************** */

    /** ***************** GET DEPARTMENT LIST DETAILS START *********************** */
    case StaffActionTypes.GET_DEPARTMENT_DROPDOWN_LIST_SUCCESS:
      return {
        ...state,
        getDepartmentDropdownListResponse: action.payload,
        getDepartmentDropdownListArr: docodeHexResponse(
          action.payload,
          "GetAllDepartmentKey",
        ),
      };

    case StaffActionTypes.GET_DEPARTMENT_DROPDOWN_LIST_FAILURE:
      return { ...state, getDepartmentDropdownListResponse: action.payload };

    case StaffActionTypes.GET_DEPARTMENT_DROPDOWN_LIST_RESPONSE_CHANGED:
      return { ...state, getDepartmentDropdownListResponse: null };
    /** ***************** GET DEPARTMENT LILST  DETAILS END *********************** */

    /** ***************** GET MANAGER LIST DETAILS START *********************** */
    case StaffActionTypes.GET_MANAGER_DROPDOWN_LIST_SUCCESS:
      return {
        ...state,
        getManagerDropdownListResponse: action.payload,
        getManagerDropdownListArr: docodeHexResponse(
          action.payload,
          "GetAllManagerDetailsKey",
        ),
      };

    case StaffActionTypes.GET_MANAGER_DROPDOWN_LIST_FAILURE:
      return { ...state, getManagerDropdownListResponse: action.payload };

    case StaffActionTypes.GET_MANAGER_DROPDOWN_LIST_RESPONSE_CHANGED:
      return { ...state, getManagerDropdownListResponse: null };
    /** ***************** GET MANAGER LILST  DETAILS END *********************** */

    default:
      return state;
  }
};
